import { useEffect, useState, useRef } from "react";
import { Link, Navigate } from 'react-router-dom';
//react toast 
import { toast } from 'react-toastify';
//custom images
import sipllogo from '../../assests/images/sipllogo.png';
//import loginpage from '../../assests/images/loginpage.png';
import logo from '../../assests/images/logo.png';
import VivaLogo from '../../assests/images/VivaLogo.png'
//loder
import BlurLoader from "../Loder/BlurLoader";
//services
import { useAuth } from "../../context/auth";
import { post } from "../../apiservices/service";
import { API_SERVER } from "../../Utils";
import { Cookies } from 'react-cookie';

const cookies = new Cookies();
const Login = () => {
    const inputrefs = useRef([]);
    const { login, user } = useAuth();

    //initial state
    const [recipe, setRecipe] = useState({ CandidateCode: '', Password: '' })
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!user) {
            inputrefs.current['txtCandidateCode'].focus();
            document.title = 'Viva HRMS : Candidate Login'
        }   
    }, [loading, user])


    //Recipe Change Handler
    const HandleChange = (prop, value) => {
        setRecipe(recipe => ({ ...recipe, [prop]: value }))
    }

    //validation handler
    const Validate = () => {
        setErrors({})
        let isValid = true;
        let validation = [
            { field: "CandidateCode", msg: 'Please Enter Candidate Code.' },
            { field: "Password", msg: 'Please Enter Password.' },
        ]

        validation.map(item => {
            if (!recipe[item.field] || recipe[item.field].length <= 0) {
                setErrors(errors => ({ ...errors, [item.field]: item.msg }));
                isValid = false;
            }
            return item;
        });

        return isValid;
    }

    //submit button Handler
    const HandleSubmit = () => {
        if (Validate()) {
            setLoading(true)
            post(`${API_SERVER}api/CandidateLogin/CandidateLogin`, { ...recipe, AuthToken:  process.env.REACT_APP_SECRET_KEY }, (res) => {
                if (res && res.status) {
                    if (res.status === "ERROR") {
                        toast.error(res.message)
                        setRecipe(recipe => ({ ...recipe, CandidateCode: '', Password: '' }))
                        setLoading(false)
                    } else {
                        //cookies.set('token', process.env.REACT_APP_SECRET_KEY);
                        //cookies.set('CandidateID', res.CandidateID);
                        //cookies.set('CandidateName', res.CandidateName);
                        //cookies.set('loginCandidateType', res.loginCandidateType);
                        //cookies.set('companyID', res.companyID);
                        //cookies.set('loginDetailsID', res.loginsessionID);
                        login(res)
                    }
                }
            });
        }
    }

    useEffect(() => {
        //console.log(user)
        cookies.remove('candidateUser', { path: '/' });
    },[])
    //if (user) {
    //    return <Navigate to="/Dashboard" />
    //} else {
        return (
            <>
                {/* Login Form Start */}
                <div className='login-page login-bg'>
                    <div className="container-fluid bg-login vh-100 d-flex justify-content-center align-items-center">
                        <div className="col-sm-3 px-4 py-3 main-login text-black rounded">
                            <center>
                                <img className="img1" src={VivaLogo} alt='login_image' />
                                <h4 className='mt-1 text-danger'>Candidate Login</h4>
                            </center>
                            <div className="">
                                <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%' }}>
                                    <div className="form-group text-start mb-3" >
                                        <label className="form-label mb-1">Candidate Code<span className='required'>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="floatingInput"
                                            ref={ref => (inputrefs.current['txtCandidateCode'] = ref)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') { inputrefs.current['txtPassword'].focus() };
                                            }}
                                            placeholder="Candidate Code"
                                            name='CandidateCode'
                                            value={recipe.CandidateCode}
                                            onChange={(e) => HandleChange('CandidateCode', e.target.value)}
                                        />

                                        {errors.CandidateCode && <div className="error-msg">{errors.CandidateCode}</div>}

                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%' }}>
                                    <div className="form-group text-start mb-3 mt-2">
                                        <label className="form-label mb-1">Password <span className='required'>*</span></label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="floatingPassword"
                                            ref={ref => (inputrefs.current['txtPassword'] = ref)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') { inputrefs.current['btnSubmit'].focus() };
                                            }}
                                            placeholder="Password"
                                            name='Password'
                                            value={recipe.Password}
                                            onChange={(e) => HandleChange('Password', e.target.value)}
                                        />

                                        {errors.Password && <div className="error-msg">{errors.Password}</div>}

                                    </div>
                                </div>
                                <div className="py-2 loading">
                                    <button
                                        ref={ref => (inputrefs.current['btnSubmit'] = ref)}
                                        className='btn-primary btn w-100'
                                        onClick={HandleSubmit}
                                    >
                                        Sign in
                                    </button>
                                    {/*<LoadingButton loading={state} disabled={isLoading} style={{ background: "var(--mycolorFilterCheckText)" }} loadingPosition='center' onClick={handleLogin} className=' py-1' variant="contained"> Login </LoadingButton>*/}
                                    {/*{isLoading && (<Loader text='AUTHENTICATING' size='100px' img_path='./assets/img/giphy.gif' />)}*/}
                                </div>
                            </div>
                            <div className='d-flex justify-content-between login-trouble mb-3'>
                                {/*<Link to='/forgotPassword'>Forgot Password ?</Link>*/}
                            </div>
                            <div className='sagar_logo text-center d-flex flex-column'>
                                <img src={sipllogo} alt='sagar logo' />
                                <Link to="https://www.sagarinfotech.com/" className='small' target='_blank'>Sagar Informatics Pvt. Ltd.</Link>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Login Form End */}

                {/* Loder start*/}
                {loading && < BlurLoader />}
                {/* Loder End*/}
            </>

        )
    }
//}

export default Login;